export const SHOP_SUB_ENTITIES = {
  shopOffers: 'shopOffers',
  shops: 'shops',
  localizedShops: 'localizedShops',
  campaignDeals: 'campaignDeals',
  adPackages: 'adPackages',
  programs: 'programs',
  imageSets: 'imageSets',
  seoDescriptions: 'seoDescriptions',
  partnerOffers: 'partnerOffers',
  conquestAds: 'conquestAds',
}
